module.exports = __webpack_public_path__ + "static/media/GN.40401eff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/GN.svg
// module id = 263
// module chunks = 0